module.exports = "/v2/pages/dashboard/dist/488f281b7c4892c39668374460d6738a.svg";